import React, { useEffect, useState } from "react";
import { Bookmark } from "lucide-react";
import { api } from "../lib/api";
import { log } from "../lib/log";
import { JourneyCard } from "./JourneyCard";

const Title = () => (
  <h2 className="font-heading text-2xl tracking-tight flex items-center gap-2">
    <Bookmark size={18} className="text-[#C8A96E]" /> Your Journeys
  </h2>
);

export default function JourneysSection() {
  const [journeys, setJourneys] = useState(null); // null = loading, [] = empty

  useEffect(() => {
    api.get("/journeys").then((r) => setJourneys(r.data || [])).catch((e) => {
      log.warn("JourneysSection: fetch failed:", e);
      setJourneys([]);
    });
  }, []);

  const handleForward = (jid) => setJourneys((list) => (list || []).map((j) => (j.journey_id === jid ? { ...j, forwarded_to_lunamore_at: new Date().toISOString() } : j)));
  const handleDelete = (jid) => setJourneys((list) => (list || []).filter((j) => j.journey_id !== jid));

  if (journeys === null || journeys.length === 0) {
    return (
      <section className="mt-10" data-testid="journeys-section">
        <div className="mb-4"><Title /></div>
        {journeys === null ? (
          <div className="glass rounded-2xl p-6 text-center text-[#A89C98]">Loading…</div>
        ) : (
          <div className="glass rounded-2xl p-8 text-center border border-white/5" data-testid="journeys-empty">
            <p className="text-sm text-[#A89C98]">No saved journeys yet. Run the Wellness Trip Planner after a scan to save a plan you love.</p>
          </div>
        )}
      </section>
    );
  }

  return (
    <section className="mt-10" data-testid="journeys-section">
      <div className="flex items-baseline justify-between mb-4">
        <Title />
        <span className="text-[10px] uppercase tracking-[0.25em] text-[#A89C98]" data-testid="journeys-count">{journeys.length} saved</span>
      </div>
      <div className="grid md:grid-cols-2 gap-4" data-testid="journeys-list">
        {journeys.map((j) => <JourneyCard key={j.journey_id} journey={j} onForward={handleForward} onDelete={handleDelete} />)}
      </div>
    </section>
  );
}
